import React from 'react';
import { Button } from './ui/button';
import { X, Gift, Lock } from 'lucide-react';

interface SignupCompletePopupProps {
  isOpen: boolean;
  onClose: () => void;
  bonusAmount: number;
}

export function SignupCompletePopup({ isOpen, onClose, bonusAmount }: SignupCompletePopupProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl">
        {/* Header */}
        <div className="flex items-start justify-between mb-5">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
                 style={{ background: 'linear-gradient(135deg, #FF8C00, #E65C00)' }}>
              <Gift className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900 leading-snug">회원가입 에어드롭</h2>
              <p className="text-base text-gray-600">지급이 완료되었습니다</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors shrink-0"
          >
            <X className="w-5 h-5 text-gray-600" />
          </button>
        </div>

        {/* 지급 금액 */}
        <div className="rounded-xl p-5 mb-4 text-center"
             style={{ background: 'linear-gradient(135deg, #FFF4E6, #FFE4CC)' }}>
          <p className="text-base font-semibold text-orange-800 mb-1">지급된 에어드롭</p>
          <p className="text-4xl font-black" style={{ color: '#E65C00' }}>
            {bonusAmount.toLocaleString()}
          </p>
          <p className="text-lg font-bold text-orange-800 mt-1">wHANDY</p>
        </div>

        {/* 활성화 안내 */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-5">
          <div className="flex items-start space-x-3">
            <div className="w-9 h-9 bg-amber-500 rounded-full flex items-center justify-center flex-shrink-0">
              <Lock className="w-5 h-5 text-white" />
            </div>
            <p className="text-base text-amber-900 leading-relaxed">
              하단 <span className="font-bold">보상</span> 메뉴에서 추천코드를 인증하면 활성화됩니다.
            </p>
          </div>
        </div>

        <Button
          onClick={onClose}
          className="w-full h-14 text-white font-bold text-lg rounded-xl shadow-lg"
          style={{ background: '#FF6B00' }}
        >
          확인
        </Button>

        <p className="text-sm text-gray-500 text-center mt-4 leading-relaxed">
          지급된 토큰은 프로젝트 정책에 따라 출금이 가능합니다.
        </p>
      </div>
    </div>
  );
}
